"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiplyByFactor = void 0;
const common_1 = require("../../../common");
function multiplyByFactor(amount, factor) {
    return common_1.roundPayment(amount * factor);
}
exports.multiplyByFactor = multiplyByFactor;
//# sourceMappingURL=factor-calculator.js.map